import '../../components/cards/course.js';
import {deferToIdle} from '../../utils/deferToIdle.js';
import {playHeroIntro} from './heroIntro.js';

/** Deferred so the hero text paints before the roll starts (FCP/LCP on mobile). */
function initSlotRoll() {
    import('../../modules/slotRoll.js').then(({playSlotRoll}) => {
        playSlotRoll(/** @type {HTMLElement} */ (document.querySelector('.js-heroSlotRoll')));
    });
}

playHeroIntro();
deferToIdle(initSlotRoll, {timeout: 2000});
